/**
 * @param {{ id?: string, config?: object }} annotationUI
 * @returns {string[]}
 */

import { validateSlideLevelClassificationConfig } from './slideLevelClassificationModel';

export function getSlideLevelClassificationConfigPublishWarnings(annotationUI) {
    const config = annotationUI?.config;
    if (!config || typeof config !== 'object') {
        return ['Add at least one question in Annotation UI configuration.'];
    }
    const issues = validateSlideLevelClassificationConfig(config);
    return issues.map((i) => i.message);
}
